import { Injectable } from '@angular/core';
import {InstiHelpers} from './instihelpers.module';

export interface BadgeItem {
  type: string;
  value: string;
}
export interface Saperator {
  name: string;
  type?: string;
}
export interface AtmMenuI{
  state: string;
  name: string;
  type?: string;
  id: number,
  parent_id?: number
}
export interface SubChildrenI extends AtmMenuI{
}
export interface ChildrenItemsI  extends AtmMenuI{
  sub_child: SubChildren[];
}
 
export interface MenuI  extends AtmMenuI {
   icon: string;
   badge?: BadgeItem[];
  saperator?: Saperator[];
  childrens?: ChildrenItems[];  
}


export const insti_helpers=new InstiHelpers();

export class AtmMenu {  // implements MenuI{
    private icon: string;
    private state: string;
    private name: string;
    private type: string;
    private id:number;
    private parent_id:number;
    private childrens:ChildrenItems[];
    private sibilings:AtmMenu[];
    private allowed_types:string[]=['saperator', //Indica o separador de nivel
                                   'link',  //Indicar que o item ´e o link 
                                   'extlink', //indica que o item é um link externo
                                   'extTabLink', //Não implementado
                                   'sub',   //indica que é um subnivel(2º nivel)
                                   'subchild'
                                   ];
    private type_instance:string='parent';//childre,subchildren                               
    private setIcon(value:string){
        //  this.icon=this.isType('saperator') || this.isType('sub') ? value : null;
         this.icon= !this.hasParentId() ? value : null;
         return this;
    } 
                                   
    private setState(value:string){
        this.state=value;
        return this;
    }
    private setName(value:string){
        this.name=value;
        return this;
    }
    private setType(value:string){
        this.type= ! this.isAllowedType(value) ? '' : value.toLowerCase();
        return this;
    }
    private setId(value:number){
         this.id=value;
        return this;
    }
    private setParentId(value:number){
        this.parent_id=insti_helpers.toInt(value);
        return this;
    }
    private setChildrens(value:any[]){
         this.childrens =  [];

      if(!this.isType('sub')){
        return this;
      }

      let limitador=0;

      do{
        let curr= value.hasOwnProperty(limitador) ? value[limitador] : null;
        
        if(!curr){
          console.log('O index '+limitador+' parece não existe. COD: 27032020192217');
          break;
        }
        if(!curr.hasOwnProperty('parent_id')){
          limitador++;
          continue;
        }
        if(insti_helpers.toInt(curr.parent_id)!= this.getId()){
          limitador++;
          continue;
        }

        value.splice(limitador,1);

        this.appendChildren(new ChildrenItems(curr, value));
        
      }
      while(limitador< value.length);

      return this;
    }
    private setTypeInstance(){
       let instance_name=this.constructor.name;
       switch(instance_name){
         case 'ChildrenItems': this.type_instance = 'children'; break;
         case 'SubChildren': this.type_instance = 'subchildren'; break;
         default: this.type_instance ='parent';
       }
       return this;
    }

    isAllowedType(p_type?:string):boolean{
        return this.getAllowedTypes().indexOf(!p_type? this.getType() : p_type.toLowerCase())>-1;
    }
    isParent():boolean{
        let p=insti_helpers.toInt(this.getParentId());
        
       return p==0 && this.isType('separador');
    }
    isType(equal:string, p_type?:string):boolean{
        return (!p_type? this.getType() : p_type.toLowerCase()) == equal.toLowerCase();
    }

    hasChildrens():boolean{
      let c=this.getChildrens();
      return insti_helpers.empty(c)? false: true;
    }
    hasSiblings():boolean{
        let s=this.getSiblings();
        return insti_helpers.empty(s)? false: true;
    }
    hasParentId(){ return insti_helpers.toInt(this.getParentId())>0; }
    getAllowedTypes():string[]{ return this.allowed_types; }
    getState():string{ return this.state; }
    getName():string{return this.name; }
    getType():string{ return this.type;}
    getIcon(): string{ return this.icon;}
    getTypeDefault(){ return 'link';}
    getId():number{ return this.id;}
    getParentId():number{ return this.parent_id;}
    
    getChildrens(){ return !this.childrens ? [] : this.childrens; }
    getSiblings(){ return this.sibilings;}
    getTypeInstance(){ return this.type_instance;} 
    


    private setup(obj, childrens){
        return this.setTypeInstance()
            .setType(obj.type|| obj.tipo ||this.getTypeDefault())
           .setName(obj.name|| obj.label)
           .setState(obj.state || obj.url_fragment)
           .setIcon(obj.icon || obj.icone) 
           .setId(obj.hasOwnProperty('id') ? obj.id : null)
           .setParentId(obj.hasOwnProperty('parent_id') ? obj.parent_id : null)
           .setChildrens(childrens);
    }

    private setSibilings(values:any){
        
        this.sibilings = [];
         if(this.getTypeInstance()=='children' || this.getTypeInstance()=='subchildren'){
           return this;
         }
        if(this.isType('sub')){
          return this;
        }

        if(!Array.isArray(values)){
          return this;
        }
        let limitador=0;
        do{
          let children:any = values.hasOwnProperty(limitador) ? values[limitador] : null;
          
          if(insti_helpers.empty(children)){
            console.log('Parece que não existe o index '+ limitador+' no array de childrens(modulo de menu). Erro COD: 27032020171336');
            break;
          }
          if(this.getId()<=0){
            console.log('O parent parece não ter um Id. Error COD: 27032020171900');
            break;
          }
          if(!children.hasOwnProperty('parent_id')){
            limitador++;
            continue;
          }

         if( insti_helpers.toInt(children.parent_id) != this.getId()){
            limitador++;
            continue;
          }
          
          let curr=values.splice(limitador,1);
          this.appendSibiling(new AtmMenu(children, values));
        }
        while(limitador<values.length);
        return this;
    }
    private appendSibiling(sibiling:AtmMenu): boolean{
      if(sibiling.hasParentId() && sibiling.getParentId() == this.getId()){
        this.sibilings.push(sibiling);  
        return true;
      }      
      return false;
    }
    private appendChildren(children:ChildrenItems){
      if(children.getId() <= 0 ||  !children.hasParentId() || children.getParentId()!= this.getId()){
        return false;
      }
  
      this.childrens.push(children);
      return true;
    }

    constructor(obj, childrens){
      this.setup(obj, childrens)
          .setSibilings(childrens);

    }
    
}

export class ChildrenItems extends AtmMenu{ // implements ChildrenItemsI{

  private sub_child:SubChildren[];

  private setSubChildrens(value:any){

    this.sub_child = null; //!this.isType('sub') ? null : value;
    if(!this.isType('sub')){
      return this;
    }

    let limitador=0;

    do{
      let curr= value.hasOwnProperty(limitador) ? value[limitador] : null;
      
      if(!curr){
        console.log('O index '+limitador+' parece não existe. COD: 27032020192352');
        break;
      }
      if(!curr.hasOwnProperty('parent_id')){
        limitador++;
        continue;
      }
      if(insti_helpers.toInt(curr.parent_id)!= this.getId()){
        limitador++;
        continue;
      }

      this.appendSubChildren(curr);
      value.splice(limitador,1);
    }
    while(limitador< value.length);

    return this;
  }
  getSubChildren(){ return !this.sub_child? [] : this.sub_child;}
  private appendSubChildren(value:SubChildren):boolean{
   
     if(value.getId() <= 0 || value.getParentId()!= this.getId()){
      return false;
    }

    this.sub_child.push(value);
    return true;
  
  
  }

  constructor(obj, childrens){
    super(obj, childrens);
    this.setSubChildrens(childrens);
  }
}
export class SubChildren extends AtmMenu { // implements SubChildrenI{
  constructor(obj, childrens){
    super(obj, null);
  }
}
